<ng-container *ngIf="type && fileAsDataUrl">
    <img *ngIf="type.includes('image/')" [src]="fileAsDataUrl" style="width: 100%;" crossorigin>

    <div *ngIf="type=='application/pdf'" style="position: relative; height: 500px;">
        <pdf-viewer [src]="fileAsDataUrl"
                    [original-size]="false">
        </pdf-viewer>
    </div>
</ng-container>


